import Hero from "@/components/sections/Hero";
import OfferSection from "@/components/sections/OfferSection";
import HowItWorks from "@/components/sections/HowItWorks";
import AIChatDemo from "@/components/sections/AIChatDemo";
import ReviewsHero from "@/components/sections/ReviewsHero";
import Testimonials from "@/components/sections/Testimonials";
import BeforeAfter from "@/components/sections/BeforeAfter";
import PricingSnapshot from "@/components/sections/PricingSnapshot";
import HonestyBlock from "@/components/sections/HonestyBlock";
import TrustBadges from "@/components/sections/TrustBadges";
import CTASection from "@/components/sections/CTASection";
import { SUCCESS_METRICS } from "@/data/content";

function StatsRow() {
  return (
    <section
      data-testid="stats-row"
      className="py-14 sm:py-20 px-5 sm:px-6 lg:px-12 border-y border-neutral-200/70"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-4 gap-y-8 sm:gap-y-10 gap-x-6">
        {SUCCESS_METRICS.map((s) => (
          <div
            key={s.label}
            data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="text-center md:text-left"
          >
            <div className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-aurora leading-none">
              {s.value}
            </div>
            <div className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-neutral-500 mt-3 sm:mt-4 font-medium">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default function HomePage() {
  return (
    <div data-testid="home-page">
      {/* 1 · The offer */}
      <Hero />
      <OfferSection />
      {/* 2 · The demos */}
      <HowItWorks />
      <AIChatDemo />
      {/* 3 · The proof */}
      <StatsRow />
      <TrustBadges />
      <ReviewsHero />
      <Testimonials />
      <BeforeAfter />
      {/* 4 · The checkout */}
      <PricingSnapshot />
      <HonestyBlock />
      <CTASection />
    </div>
  );
}
